<template>
	<div>
		<div class="card mb-4">
	        <div class="card-header">
				<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Itens</strong>
		            </div>
		            <button
		            	@click="create()"
		            	class="btn btn-primary noprint">
		            	Novo
		            </button>
			    </div>
		    </div>
		    <div class="card-body">
		        <item-table
		        	@show="show">
		        </item-table>
		    </div>
		</div>
		<item-create
			@reload="reload">
		</item-create>
	</div>
</template>

<script>
	export default {
		methods: {
			create(){
				//this.$router.push('/adm/itens/create/'+this.$route.params.id)
				$('#create_item').modal('show');
			},
			show(id){
				this.$router.push('/adm/itens/show/'+id)
			},
			reload(){
				this.$emit('reload')
			}
		}
	}
</script>
